exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pagin-block .current{background-color:#3ec19d;color:#fff;border-radius:2px}.pagin-block{max-width:700px;float:right;margin-top:8px}.pagin-block .quantity{float:left;margin-right:35px}.pagin-block .quantity p{font-size:14px;color:#768589;line-height:1.2;margin-top:3px}.pagin-block a{display:block;min-width:21px;width:100%;text-align:center;line-height:20px;color:inherit!important;text-decoration:none;font-size:14px;font-family:Open Sans,sans-serif;font-weight:600}.pagin-block li{float:left;margin-left:5px;margin-right:5px;color:#898989;min-width:0!important}.pagin-block li:first-child,.pagin-block li:last-child{width:32px;height:25px;line-height:25px;text-align:center;color:#898989}.pagin-block .disabled{color:#bbb!important}.appbundle-paging{display:block!important;padding-left:0;margin:0!important;border-radius:0}@media (max-width:768px){.appbundle-paging{bottom:25px;left:calc(50% - 130px);display:block;float:none;width:260px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/pagination/pagination.css
// module id = 544
// module chunks = 0